import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function TipsTricksPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-tips-tricks-2026")!;
  return <ArticleLayout article={article} />;
}